import { atomWithReset as stateSegmentWithReset } from 'jotai/utils';
import { CannedParams } from '../../../types/Content';
import { EmailModulesData } from '../../../types/EmailModules';

export type BrandDetailsModuleOptionsType = {
  id: string;
  label: string;
  name: string;
};

type BrandDetailsOptionsType = {
  loading: boolean;
  options: (CannedParams | EmailModulesData)[];
  isFetched?: boolean;
  isSuccess?: boolean;
};

export type BrandDetailsFilterOptionTypes = {
  countriesOptions: BrandDetailsOptionsType;
  brandsOptions: BrandDetailsOptionsType;
  indicationsOptions: BrandDetailsOptionsType;
  audiencesOptions: BrandDetailsOptionsType;
  primaryMessagesOptions: BrandDetailsOptionsType;
  languageOptions: BrandDetailsOptionsType;
};

export type BrandDetailsFiltersStateTypes = {
  countriesOptions: BrandDetailsOptionsType;
  brandsOptions: BrandDetailsOptionsType;
  indicationsOptions: BrandDetailsOptionsType;
  audiencesOptions: BrandDetailsOptionsType;
  primaryMessagesOptions: BrandDetailsOptionsType;
  languageOptions: BrandDetailsOptionsType;
  country: string;
  brand: string;
  indication: string;
  language: string;
  targetAudience: string[];
  topics: string[];
};

export const brandDetailsFiltersStateSegment =
  stateSegmentWithReset<BrandDetailsFiltersStateTypes>({
    countriesOptions: { loading: false, options: [] },
    brandsOptions: { loading: false, options: [] },
    indicationsOptions: { loading: false, options: [] },
    audiencesOptions: { loading: false, options: [] },
    primaryMessagesOptions: { loading: false, options: [] },
    languageOptions: { loading: false, options: [] },
    country: '',
    brand: '',
    indication: '',
    language: '',
    targetAudience: [],
    topics: [],
  });

brandDetailsFiltersStateSegment.debugLabel = 'brandDetailsFiltersStateSegment';
